import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import "../../pages/companyMaster/CompanyMasterView.css";

const CompanyMasterView = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [company, setCompany] = useState(null);

    const fetchCompanyDetails = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/trading-partner/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setCompany(response.data);
        } catch (error) {
            console.error(error);
            toast.error("Failed To Fetch Company Details");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchCompanyDetails();
        }
    }, [id]);

    const DetailCard = ({ label, value }) => (
        <div className="detail-card">
            <span className="detail-label">{label}</span>
            <div className="detail-value">{value || "-"}</div>
        </div>
    );

    return (
        <Layout>
            <div className="backgound-main-content company-view-wrapper">
                <div className="container-fluid">

                    <div className="company-header">
                        <h6 className="company-title">
                            Company Details
                        </h6>

                        <button
                            className="btn btn-secondary back-btn"
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </button>
                    </div>

                    {loading ? (
                        <div className="loading-container">
                            <div
                                className="spinner-border text-primary"
                                role="status"
                            />
                        </div>
                    ) : company ? (
                        <div className="company-main-card">

                            <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                                <h4 className="mb-0 fw-bold">
                                    {company.organizationName ||
                                        `${company.firstName || ""} ${company.lastName || ""}`}
                                </h4>

                                <span
                                    className={
                                        company.active
                                            ? "status-active"
                                            : "status-inactive"
                                    }
                                >
                                    {company.active
                                        ? "Active"
                                        : "Inactive"}
                                </span>
                            </div>

                            {/* Basic Information */}
                            <div className="company-section">
                                <h4 className="section-heading">
                                    Basic Information
                                </h4>

                                <div className="details-grid">
                                    <DetailCard
                                        label="First Name"
                                        value={company.firstName}
                                    />

                                    <DetailCard
                                        label="Middle Name"
                                        value={company.middleName}
                                    />

                                    <DetailCard
                                        label="Last Name"
                                        value={company.lastName}
                                    />

                                    <DetailCard
                                        label="Organization Name"
                                        value={company.organizationName}
                                    />

                                    <DetailCard
                                        label="GST Number"
                                        value={company.gstNumber}
                                    />
                                </div>
                            </div>

                            {/* Contact Details */}
                            <div className="company-section">
                                <h4 className="section-heading">
                                    Contact Details
                                </h4>

                                <div className="details-grid">
                                    <DetailCard
                                        label="Email"
                                        value={company.email}
                                    />

                                    <DetailCard
                                        label="Alternate Email"
                                        value={company.alternateEmail}
                                    />

                                    <DetailCard
                                        label="Mobile Number"
                                        value={company.mobileNumber}
                                    />

                                    <DetailCard
                                        label="Alternate Mobile"
                                        value={company.alternateMobileNumber}
                                    />

                                    <DetailCard
                                        label="GST Type"
                                        value={company.gstType}
                                    />
                                </div>
                            </div>

                            {/* Address Details */}
                            <div className="company-section">
                                <h4 className="section-heading">
                                    Address Details
                                </h4>

                                <div className="details-grid">
                                    <DetailCard
                                        label="Landmark"
                                        value={company.address?.landMark}
                                    />

                                    <DetailCard
                                        label="Street Line 1"
                                        value={company.address?.streetLine1}
                                    />

                                    <DetailCard
                                        label="Street Line 2"
                                        value={company.address?.streetLine2}
                                    />

                                    <DetailCard
                                        label="City"
                                        value={company.address?.city}
                                    />

                                    <DetailCard
                                        label="State"
                                        value={company.address?.state}
                                    />

                                    <DetailCard
                                        label="Postal Code"
                                        value={company.address?.postalCode}
                                    />

                                    <DetailCard
                                        label="Country"
                                        value={company.address?.country}
                                    />

                                    <DetailCard
                                        label="Metadata"
                                        value={company.address?.metadata}
                                    />
                                </div>
                            </div>

                        </div>
                    ) : (
                        <div className="text-center py-5">
                            No Data Found
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default CompanyMasterView;